// src/components/AccessDeniedDialog.tsx
import React, { useEffect, useState } from 'react';
import { ArrowLeft, Home, Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useUIStore } from '../store/uiStore';

interface AccessDeniedDialogProps {
  moduleName?: string;
}

export const AccessDeniedDialog: React.FC<AccessDeniedDialogProps> = ({ moduleName }) => {
  const navigate = useNavigate();
  const [isAnimate, setIsAnimate] = useState(false);
const { setAccessDenied, setLoading } = useUIStore(); // Store'dan al
  useEffect(() => {
    // Sayfa yüklendiğinde ufak bir delay ile animasyonu başlat
    const timer = setTimeout(() => setIsAnimate(true), 50);
    return () => clearTimeout(timer);
  }, []);

const handleClose = (path: string | number) => {
  setIsAnimate(false);
  
  // 1. Önce her türlü kısıtlamayı kaldır
  setAccessDenied(false); 
  setLoading(false); 

  // 2. Sonra yönlendir
  setTimeout(() => {
    if (typeof path === 'number') navigate(-1);
    else navigate(path);
  }, 300);
};

  return (
    <div className={`fixed inset-0 z-[9999] flex items-center justify-center p-4 transition-all duration-500 ${isAnimate ? 'opacity-100 backdrop-blur-md bg-black/20' : 'opacity-0 backdrop-blur-none bg-black/0'}`}>
      
      {/* Modal Container */}
      <div 
        className={`relative w-full max-w-[500px] overflow-hidden rounded-[2.5rem] border borderx transition-all duration-500 transform
          ${isAnimate ? 'scale-100 translate-y-0' : 'scale-90 translate-y-12'}
         `}
      >
        
        {/* Dekoratif Arka Plan İkonu */}
        <div className="absolute -top-6 -right-6 opacity-[0.03] pointer-events-none rotate-12">
          <Lock size={180} />
        </div>

        <div className="flex flex-col items-center p-8 text-center text-text">
          
          {/* Ana İkon Alanı */}
          <div className="relative mb-8">
            <div className="w-24 h-24 rounded-full flex items-center justify-center bg-danger/5 animate-pulse border border-red-400">
              <div className="w-16 h-16 rounded-full flex items-center justify-center bg-danger/10 shadow-inner">
                <Lock size={32} className="text-danger" />
              </div>
            </div>
          </div>

          <h3 className="text-2xl font-bold tracking-tight mb-3">
            Erişim Engellendi
          </h3>
          
          <p className="opacity-60 text-sm leading-relaxed mb-10 max-w-[280px]">
            İncelemeye çalıştığınız bölüm için yetkiniz bulunmamaktadır. Lütfen sistem yöneticinizle görüşün.
          </p>

          {/* Modül Bilgi Kartı - Senin card2 stilin */}
        <div className="card2 w-full py-5 px-4 flex flex-col items-center gap-1 border-dashed mb-8">
  <span className="text-[10px] uppercase font-bold tracking-widest opacity-40">
    Sistem Mesajı
  </span>
  <p className="text-danger font-medium text-sm uppercase tracking-wide px-2">
    {moduleName || "Erişim Reddedildi"}
  </p>
</div>

          {/* Butonlar */}
          <div className="flex flex-col sm:flex-row justify-center gap-3 w-full">
            <button
              onClick={() => handleClose(-1)}
              className="flex items-center justify-center gap-2 px-6 py-3 btn-cancel flex-1 transition-transform active:scale-95"
            >
              <ArrowLeft size={18} /> 
              <span>Geri Dön</span>
            </button>
            <button
              onClick={() => handleClose('/')}   
              className="flex items-center justify-center gap-2 px-6 py-3 btn-new flex-1 transition-transform active:scale-95"
            >
              <Home size={18} /> 
              <span>Ana Sayfa</span>
            </button>
          </div>
        </div>

        {/* Alt Bilgi */}
        <div className="w-full h-1 bg-gradient-to-r from-transparent via-danger/20 to-transparent" />
      </div>
    </div>
  );
};